import { render, staticRenderFns } from "./customizableGauge.vue?vue&type=template&id=ff8c0452&scoped=true"
import script from "./customizableGauge.vue?vue&type=script&lang=js"
export * from "./customizableGauge.vue?vue&type=script&lang=js"
import style0 from "./customizableGauge.vue?vue&type=style&index=0&id=ff8c0452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c0452",
  null
  
)

export default component.exports